import { BrowserRouter as Router, Switch } from 'react-router-dom';
import SignIn from './feature/authentication/pages/SignIn';
import SignUp from './feature/authentication/pages/SignUp';
import TermOfService from './Pages/TermOfService';
import Privacy from './Pages/Privacy';
import About from './Pages/About';
import GlobalProvider from './services/global/GlobalState';
import { ThemeProvider } from '@material-ui/core';

import ContactUs from './Pages/ContactUs';
import Jobs from './Pages/Jobs';
import { ProfileContextProvider } from './services/profile/profile.context';
import { AuthenticationContextProvider } from './services/authentication/authentication.context';
import { CreateMeetingContainer } from './feature/create-meeting/pages/create-meeitng-container';
import { theme } from './theme/color';
import { TimeTableContainer } from './feature/prefer-time/pages/time-table-container';
import { AppSettingLayout } from './components/Layouts/app/app-setting-layout';
import ConnectAccount from './feature/connections/connectAccount';
import { ChangePassword } from './feature/change-password/change-password';
import { UserProfile } from './feature/user-profile/page/user-profile';
import { UserTimezone } from './components/user-time-zone';
import { UserLocation } from './feature/user-location/user-location-container';
import { Meetings } from './feature/meeting/page/meetings';
import { MeetingDetailsContainer } from './feature/meeting-detail/page/meeting-details-container';
import Forget_password from './feature/authentication/forget-password/Forget_password';
import Reset_password from './feature/authentication/forget-password/Reset_password';
import { PreferLocationContextProvider } from './services/prefer-location/prefer-location.context';
import { PreferLocationContainer } from './feature/prefer-location/page/prefer-location-container';
import { PreferTimeContextProvider } from './services/prefer-time/prefer-time.context';
import { EmailVerification } from './feature/authentication/pages/email-verification';
import { ConfirmEmailAddress } from './feature/authentication/pages/confirm-email-address';
import { ActivationError } from './feature/authentication/pages/activation-error';
import { MainLayout } from './components/Layouts/home/main-layout';
import { AppLayout } from './components/Layouts/app/app-layout';
import { PublicProfileContainer } from './feature/public-profile/page/public-user-profile-container';
import { Explore } from './feature/public-meeting/page/explore';
import { HomePage } from './components/Layouts/home/home-page/home-page';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <GlobalProvider>
          <AuthenticationContextProvider>
            <Switch>
              <MainLayout exact path='/' component={HomePage} />
              <MainLayout
                path='/signup/confirm'
                component={EmailVerification}
              />
              <MainLayout
                path='/signin/verify-email'
                component={ActivationError}
              />
              <MainLayout exact path='/signin' component={SignIn} />
              <MainLayout path='/signup' component={SignUp} />
              <MainLayout
                path='/account-confirm-email/:key'
                component={ConfirmEmailAddress}
              />
              <MainLayout path='/forget_password' component={Forget_password} />
              <MainLayout path='/terms' component={TermOfService} />
              <MainLayout path='/privacy' component={Privacy} />
              <MainLayout path='/about' component={About} />
              <MainLayout path='/jobs' component={Jobs} />
              <MainLayout path='/contact' component={ContactUs} />
              <MainLayout
                path='/signin/:oauth_token/:oauth_verifier'
                component={SignIn}
              />
            </Switch>
            <Switch>
              <ProfileContextProvider>
                <MainLayout
                  path='/api/password_reset/confirm/:token'
                  component={Reset_password}
                />
                <AppLayout
                  path='/user/profile/:user'
                  component={PublicProfileContainer}
                />
                <AppLayout path='/explore' component={Explore} />
                <AppLayout path={'/meetings'} component={Meetings} />
                <AppLayout
                  path={'/createmeeting'}
                  component={CreateMeetingContainer}
                />
                <AppLayout
                  path={'/updatemeeting/:id'}
                  component={CreateMeetingContainer}
                />
                <AppLayout path='/coming-soon' component={Jobs} />
                <AppLayout
                  path='/meetings-details/:id'
                  component={MeetingDetailsContainer}
                />
                <PreferTimeContextProvider>
                  <PreferLocationContextProvider>
                    <AppSettingLayout
                      path={'/account/profile'}
                      component={UserProfile}
                    />
                    <AppSettingLayout
                      path={'/account/prefer-time'}
                      component={TimeTableContainer}
                    />
                    <AppSettingLayout
                      path={'/account/change-password'}
                      component={ChangePassword}
                    />
                    <AppSettingLayout
                      path={'/account/location'}
                      component={UserLocation}
                    />
                    <AppSettingLayout
                      path={'/account/social-account'}
                      component={ConnectAccount}
                    />
                    <AppSettingLayout
                      path={'/account/prefer-location'}
                      component={PreferLocationContainer}
                    />
                    <AppSettingLayout
                      path={'/account/timezone'}
                      component={UserTimezone}
                    />
                  </PreferLocationContextProvider>
                </PreferTimeContextProvider>
              </ProfileContextProvider>
            </Switch>
          </AuthenticationContextProvider>
        </GlobalProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
